import { calcDays, HistoryCriteria } from '../../../domain/history/HistoryCriteria'
import httpBuildQuery from '../../../httpBuildQuery'

export const FETCH_DAILY_REPORTS = 'V2/DailyReport/Fetch'
export const FETCH_DAILY_REPORTS_TIME_EXPLORER = 'V2/DailyReport/TimeExplorer/Fetch'
export const FETCH_DAILY_REPORTS_TRANSACTION = 'V2/DailyReport/Transaction/Fetch'

export const fetchDailyReports = () => ({
    type: FETCH_DAILY_REPORTS,
    payload: ({ fetchForApplication }) => fetchForApplication('/history/daily-reports'),
})

export const fetchDailyReportsFor = (criteria: HistoryCriteria) => ({
    type: FETCH_DAILY_REPORTS,
    payload: ({ fetchForApplication }) => {
        const { environment, service, serviceType, date, granularity } = criteria
        const days = calcDays(date, granularity)
        const query = { env: environment, s: service, start: days[0], end: days[days.length - 1], st: serviceType }

        return fetchForApplication('/history/daily-reports?' + httpBuildQuery(query)).then(data => ({ criteria, data }))
    },
})

export const fetchTransactionReportsFor = (criteria: HistoryCriteria, transactionId: number) => ({
    type: FETCH_DAILY_REPORTS_TRANSACTION,
    payload: ({ fetchForApplication }) => {
        const { environment, service, serviceType, date, granularity } = criteria
        const days = calcDays(date, granularity)
        const query = { env: environment, s: service, start: days[0], end: days[days.length - 1], o: transactionId, st: serviceType }

        return fetchForApplication('/history/transactions/' + transactionId + '?' + httpBuildQuery(query)).then(data => ({
            criteria,
            transactionId,
            data,
        }))
    },
})

export const fetchTimeExplorerReportFor = (environment: string, service: string) => ({
    type: FETCH_DAILY_REPORTS_TIME_EXPLORER,
    payload: ({ fetchForApplication }) => {
        const criteria = { env: environment, s: service }

        return fetchForApplication('/history/graph/time-explorer?' + httpBuildQuery(criteria)).then(data => ({
            environment,
            service,
            data,
        }))
    },
})
